import Axios from 'axios'
import { Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setResumen } from '../../app/contaSlice'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function DatagridGroupedRows({ title, month, year, data, url, headers }) {

  const dispatch = useDispatch()
  //console.log(data)

  const fetchInfo = useSelector(state => state.conta.info)
  const startDate = useSelector(state => state.conta.info.FIni)
  const endDate = useSelector(state => state.conta.info.FFin)

  const handleClick = async (params) => {
    try {
      const configObj = {
        method: 'get',
        url: url,
        headers: headers,
        params: params,
      }
      const response = await Axios(configObj)
      dispatch(setResumen({
        data: response.data,
        Opcion: (params.Opcion === '2' ? 'Usuario' : 'Cargo'),
        IdEmpresa: params.IdEmpresa,
        IdSede: params.IdSede,
      }))
    }
    catch (err) {
      console.log(err)
    }
  }

  const formattedData = datagridFormatter(data, fetchInfo.Opcion)
  //console.log(formattedData)

  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-5 bg-primarioMira h-full rounded-lg">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-lg font-semibold text-white"> Resumen de ingresos</h1>
          <h2 className="text-lg font-semibold text-white"> {title} - {month} {year} </h2>
          <p className="mt-2 text-sm text-grisMira">
            Ingresos totales por empresa, sede y forma de pago.
          </p>
        </div>
      </div>
      <div className="mt-5 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle lg:px-8 pb-4 lg:pb-8">
            <div className="overflow-hidden shadow-lg ring-1 ring-black ring-opacity-5 lg:rounded-lg">
              <table className="min-w-full">
                <thead className="bg-secundarioMira">
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6">
                      <span className='sr-only'>Subtitulo</span>
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                      Pagos en línea
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                      Agencias bancarias
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                      Reg. boleta
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                      Efectivo
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                      P.O.S.
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                      Total
                    </th>
                    {
                      fetchInfo.Opcion !== '0' ?
                        <>
                          <th scope="col" className="px-3 py-3.5 sm:pr-6">
                            <span className="sr-only">Resumen por cargo</span>
                          </th>
                          <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                            <span className="sr-only">Resumen por usuario</span>
                          </th>
                        </>
                        : null
                    }
                    {/*
                      fetchInfo.Opcion === '0' ?
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span className="sr-only">Ver más</span>
                      </th>
                      : null
                    */}
                  </tr>
                </thead>
                <tbody className="bg-secundarioMira">
                  {formattedData.map((data) => (
                    <Fragment key={data.nombre}>
                      <tr className="border-t border-white">
                        <th
                          colSpan={5}
                          scope="colgroup"
                          className={`bg-primarioMira px-4 py-2 text-left text-sm font-semibold text-white sm:px-6 ${data.nombre === 'Total' ? 'hidden' : null}`}
                        >
                          {data.nombre}
                        </th>
                      </tr>
                      {data.info.map((canal, canalIdx) => (
                        <tr
                          key={canal.cybersource}
                          className={classNames(canalIdx === 0 && data.nombre === 'Total' ? 'border-white bg-primarioMira' : 'border-gray-200', 'border-t')}
                        >
                          <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 ${data.nombre === 'Total' ? 'text-white' : 'text-grisMira'}`}>
                            {canal.titulo}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{canal.cybersource}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{canal.bancos}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{canal.boletas}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{canal.efectivo}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{canal.POS}</td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-white">{canal.totales}</td>
                          {
                            fetchInfo.Opcion !== '0' ?
                              <>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira font-medium">
                                  <button className={`text-indigo-500 hover:underline ${data.nombre === 'Total' ? 'hidden' : null}`}
                                    onClick={() => handleClick(
                                      {
                                        Opcion: '2',
                                        FIni: startDate,
                                        FFin: endDate,
                                        IdEmpresa: data.info[0].IdEmpresa,
                                        IdSede: data.info[0].IdSede,
                                      })}
                                  >
                                    Por usuario
                                  </button>
                                </td>
                                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                  <button className={`text-secundario hover:underline ${data.nombre === 'Total' ? 'hidden' : null}`}
                                    onClick={() => handleClick(
                                      {
                                        Opcion: '3',
                                        FIni: startDate,
                                        FFin: endDate,
                                        IdEmpresa: data.info[0].IdEmpresa,
                                        IdSede: data.info[0].IdSede,
                                      })}
                                  >
                                    Por cargo
                                  </button>
                                </td>
                              </>
                              : null
                          }
                          {/*
                            fetchInfo.Opcion === '0' ?  
                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              <button className={`text-secundario hover:underline ${data.nombre === 'Total' ? 'hidden' : null}`}
                              onClick={() => console.log({
                                opcion: '1',
                                Fini: '',
                                FFin: '',
                                IdEmpresa: data.info[0].id,
                              })}
                              >
                                Ver más
                              </button>
                            </td>
                            : null
                          */}
                        </tr>
                      ))}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const datagridFormatter = (rawDataReports, option) => {

  let data = []

  rawDataReports.map((objReport, index) => {
    data.push({
      nombre: (index < (rawDataReports.length - 1) ? (option === '0' ? objReport.Empresa : objReport.Sede) : 'Total'),
      info: [
        {
          IdEmpresa: (index < (rawDataReports.length - 1) ? objReport.IdEmpresa : null),
          IdSede: (index < (rawDataReports.length - 1) ? objReport.IdSede : null),
          titulo: (index < (rawDataReports.length - 1) ? 'Total por forma de pago' : 'TOTAL'),
          cybersource: (index < (rawDataReports.length - 1) ? objReport.Cybersource : objReport.Total_Cybersource),
          bancos: (index < (rawDataReports.length - 1) ? objReport.Bancos : objReport.Total_Bancos),
          boletas: (index < (rawDataReports.length - 1) ? objReport.Boleta : objReport.Total_Boleta),
          efectivo: (index < (rawDataReports.length - 1) ? objReport.Efectivo : objReport.Total_Efectivo),
          POS: (index < (rawDataReports.length - 1) ? objReport.POS : objReport.Total_POS),
          totales: (index < (rawDataReports.length - 1) ? objReport.Totales : objReport.Total_Totales)
        }
      ]
    })

    return data
  })

  return data

}

